import { Check } from "lucide-react";

import type { PreviewTheme } from "../shell/TvFrameTheme";
import { LOOKS, lookIdOf, type LookTokens } from "./catalog";

/* Looks as swatch cards (contract v2.1 section 3): a tiny dashboard drawn in
 * CSS in the Look's own colours, for the mode the canvas is previewing, plus
 * one line on when to use it. */

function Mini({ t }: { t: LookTokens }) {
  const card = { background: t.card, border: `1px solid ${t.border}`, borderRadius: t.radius, boxShadow: t.shadow };
  const title = { color: t.title, fontWeight: t.titleWeight, textTransform: t.upper ? ("uppercase" as const) : undefined };
  return (
    <div className="st-look__mini" style={{ background: t.stage }} aria-hidden="true">
      <div className="st-look__kpis">
        {[0, 1, 2].map((i) => (
          <div key={i} className="st-look__kpi" style={card}>
            <span className="st-look__kt" style={{ background: t.text }} />
            <span className="st-look__kv" style={{ ...title, color: i === 0 ? t.accent[0] : t.title }}>{["42K", "87%", "$1.2M"][i]}</span>
          </div>
        ))}
      </div>
      <div className="st-look__chart" style={card}>
        <span className="st-look__ct" style={title}>Cost by month</span>
        <div className="st-look__bars">
          {[45, 70, 55, 88, 64, 76].map((h, i) => (
            <span key={i} style={{ height: `${h}%`, background: t.accent[i % 2], borderRadius: t.radius > 6 ? 2 : 0 }} />
          ))}
        </div>
      </div>
    </div>
  );
}

export function LookPicker({ value, mode, onChange }: { value: string | undefined; mode: PreviewTheme; onChange: (id: string) => void }) {
  const current = lookIdOf(value);
  return (
    <div className="st-looks" role="radiogroup" aria-label="Look">
      {LOOKS.map((l) => {
        const on = l.id === current;
        return (
          <button key={l.id} type="button" role="radio" aria-checked={on} className={`st-look${on ? " is-on" : ""}`} onClick={() => !on && onChange(l.id)}>
            <Mini t={l.preview[mode]} />
            <span className="st-look__text">
              <span className="st-look__name">
                {l.label}
                {on ? <Check size={13} /> : null}
              </span>
              <span className="st-look__best">{l.bestFor}</span>
            </span>
          </button>
        );
      })}
      <div className="ds-small ds-faint">Previews show the {mode} version — switch Light/Dark above the canvas to compare. Every Look works in both.</div>
    </div>
  );
}
